export { generateApp } from './generator-service.js';
